// eslint-disable-next-line no-restricted-imports
import FeatureGates from '@atlaskit/feature-gate-js-client';
import { checkThirdParty } from '@atlassian/browser-storage-controls';

/**
 * Function to check if the Atlassian Third Party Loader is ready to use.
 *
 * @returns boolean
 */
export function isAtlThirdPartyLoaderAvailable(): boolean {
  if (!FeatureGates.initializeCompleted?.()) {
    return false;
  }

  const isAtlThirdPartyLoaderGateEnabled = FeatureGates.checkGate(
    'tplat_atl_third_party_loader',
  );

  // we want to fail gracefully if the feature gate or feature is not available
  const isAtlThirdPartyLoaderReady = isAtlThirdPartyLoaderGateEnabled
    ? Boolean(checkThirdParty)
    : false;

  return isAtlThirdPartyLoaderReady;
}
